import { Snowflake, Info } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { OFF_SEASON } from "@/lib/books";

export const OffSeason = () => (
  <section className="py-24 text-white" style={{ backgroundColor: "var(--navy)" }} data-testid="books-off-season">
    <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1fr_1.2fr] gap-12 items-start">
      <Reveal>
        <Snowflake size={30} style={{ color: "var(--turquoise)" }} />
        <h2 className="font-display text-4xl md:text-5xl leading-tight mt-6" data-testid="books-off-season-title">{OFF_SEASON.title}</h2>
      </Reveal>
      <Reveal delay={0.1}>
        {OFF_SEASON.body.map((p) => (
          <p key={p.slice(0, 20)} className="font-body font-light text-base leading-relaxed text-white/80 mb-5">{p}</p>
        ))}
        <div className="flex items-start gap-3 mt-8 p-5 rounded-2xl border" style={{ borderColor: "rgba(212,175,55,0.35)" }}>
          <Info size={18} className="shrink-0 mt-0.5" style={{ color: "var(--gold)" }} />
          <p className="font-body text-sm leading-relaxed text-white/75" data-testid="books-off-season-disclaimer">{OFF_SEASON.disclaimer}</p>
        </div>
      </Reveal>
    </div>
  </section>
);
